import React from 'react';
import { TEAM_ENABLED } from '../../constants/featureFlags';
import TeamView from './TeamView';

/** Renders the Team screen only while the TEAM_ENABLED flag is on. */
const TeamRoute: React.FC = () => (TEAM_ENABLED ? <TeamView /> : null);

export default TeamRoute;
